<template>
    <div class="mw-calendar">
        <component 
            :is="view"
            :events="events"
            :currentDate="date"
            @gotoDate="gotoDate"
            @changeView="changeView"
            v-on="$listeners"
            ref="currentViewRef"
        />

    </div>
</template>


<script>

    import DayGridMonth from './view/DayGridMonth.vue'
    import TimeGridWeek from './view/TimeGridWeek.vue'
    import DayGridWeek from './view/DayGridWeek.vue'

    export default {
        
        components: {
            'dayGridMonth': DayGridMonth,
            'timeGridWeek': TimeGridWeek,
            'dayGridWeek': DayGridWeek,
        },

        props: {
            initialEvent: {
                type: Array,
            },
            initialDate: {
                type: String,
                default: ()=> new Date().toISOString(),
            },
            initialView: {
                type: 'dayGridMonth' | 'timeGridWeek' | 'dayGridWeek',
                default: 'dayGridMonth',
            },
        },

        data() {
            return {
                view: this.initialView,
                date: this.initialDate,
                events: this.initialEvent,
            }
        },

        methods: {
            getApi() {
                const self = this;
                return new Proxy({}, {
                    get(target, prop) {

                        // 1. Priorité au Planner (Parent)
                        if (prop in self) {
                            return typeof self[prop] === 'function' ? self[prop].bind(self) : self[prop];
                        }

                        // 2. Ensuite la vue active (Enfant)
                        const child = self.$refs.currentViewRef;
                        if (child && prop in child) {
                            return typeof child[prop] === 'function' ? child[prop].bind(child) : child[prop];
                        }

                        // 3. Sécurité : si on appelle une fonction qui n'existe pas
                        // on retourne une fonction vide pour éviter le crash
                        return () => { 
                            console.warn(`La méthode "${prop}" n'existe pas dans la vue actuelle.`);
                        };
                    }
                });
            },
            getDate() {
                console.log('getDate calendar', this.date)
                return new Date(this.date);
            },
            gotoDate(date) {
                console.log('gotoDate calendar', date)
                this.date = date
            },
            today() {
                this.date = new Date().toISOString();
            },
            changeView(viewName) {
                console.log('changeView calendar', viewName)
                if (['dayGridMonth', 'timeGridWeek', 'dayGridWeek'].includes(viewName)) {
                    this.view = viewName;
                }
            },
            addEvents(events) {
                this.events = events;
            },

            removeAllEvents() {
                this.events = [];
            },

            removeEvent(eventId) {
                const index = this.events.findIndex(event => event.id === eventId);
                if (index !== -1) {
                    this.$delete(this.events, index);
                }
            },

            setOption(optionName, value) {
                if (this[optionName] == undefined) return
                this[optionName] = value;
            },

            eventDragStop(info) {
                this.$emit('eventDragStop', info);
            },

            eventDragStart(info) {
                this.$emit('eventDragStart', info);
            },
            getEventById(eventId) {
                console.log('getEventById',this.events.findIndex(event => event.id === eventId))
                return this.events.find(event => event.id === eventId);
            },

            setPropsEvent(eventId, propsName, value) {
                const eventIndex = this.events.findIndex(event => event.id === eventId);
                if (eventIndex !== -1) {
                    this.$set(this.events[eventIndex], propsName, value);
                }
            }
        },
        
    }
</script>
